import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';



@Injectable()
export class RouteUtilService {
  /*********************Properties*********************/
  get activeUrl(): string {
    return this.currUrl;
  }

  private prevUrl: any = null;
  private currUrl: any = null;
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.prevUrl = this.currUrl;
        this.currUrl = e.url;
      });
  }
  /*********************Constructor*********************/

  /*********************Utility Methods*********************/

  navigate(url: any, data: any = null): void {
    this.router.navigateByUrl(url, { state: data, replaceUrl: true });
  }
  redirectToLogin() {
    this.navigate('');
  }

}
